module.exports = __webpack_public_path__ + "media/sound.401f7794.mp3";